import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
    background: linear-gradient(135deg, #1178d4 0%, #209fff 50%, #45b5ff 100%);
    display: flex;
    align-items: center;
    justify-content: center;
`

const Svg = styled.svg`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
`


const nodes = [
    { x: 120, y: 80, r: 4 },
    { x: 280, y: 180, r: 3 },
    { x: 90, y: 340, r: 5 },
    { x: 350, y: 420, r: 3 },
    { x: 200, y: 560, r: 4 },
    { x: 480, y: 100, r: 3 },
    { x: 560, y: 320, r: 4 },
    { x: 700, y: 60, r: 3 },
    { x: 750, y: 640, r: 3 },
    { x: 920, y: 120, r: 4 },
    { x: 1050, y: 280, r: 3 },
    { x: 980, y: 500, r: 5 },
    { x: 1150, y: 100, r: 3 },
    { x: 1200, y: 400, r: 4 },
    { x: 1300, y: 200, r: 3 },
    { x: 1350, y: 580, r: 4 },
    { x: 60, y: 620, r: 3 },
    { x: 440, y: 600, r: 3 },
    { x: 1100, y: 620, r: 3 },
    { x: 680, y: 200, r: 3 },
]

const edges = [
    [0, 1], [1, 2], [2, 4], [3, 4], [1, 5],
    [5, 7], [6, 3], [7, 9], [9, 12], [10, 11],
    [11, 13], [12, 14], [13, 15], [8, 11], [16, 2],
    [17, 8], [18, 15], [5, 19], [19, 6], [9, 10],
    [14, 15], [0, 5], [10, 13],
]

const orbs = [
    { cx: 200, cy: 160, r: 80 },
    { cx: 1200, cy: 540, r: 100 },
    { cx: 700, cy: 350, r: 140 },
    { cx: 1050, cy: 100, r: 60 },
    { cx: 400, cy: 580, r: 70 },
]

export default function VersionBanner({ version }) {
    return (
        <Wrapper>
            <Svg viewBox="0 0 1400 703" preserveAspectRatio="xMidYMid slice">
                {orbs.map((orb, i) => (
                    <circle
                        key={`orb-${i}`}
                        cx={orb.cx}
                        cy={orb.cy}
                        r={orb.r}
                        fill="url(#orbGlow)"
                        opacity={0.15 + (i % 3) * 0.05}
                    />
                ))}

                {edges.map(([a, b], i) => (
                    <line
                        key={`edge-${i}`}
                        x1={nodes[a].x}
                        y1={nodes[a].y}
                        x2={nodes[b].x}
                        y2={nodes[b].y}
                        stroke="rgba(255, 255, 255, 0.15)"
                        strokeWidth="1"
                    />
                ))}

                {nodes.map((node, i) => (
                    <circle
                        key={`node-${i}`}
                        cx={node.x}
                        cy={node.y}
                        r={node.r}
                        fill="rgba(255, 255, 255, 0.3)"
                    />
                ))}

                <defs>
                    <radialGradient id="orbGlow">
                        <stop offset="0%" stopColor="#ffffff" stopOpacity="0.8" />
                        <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
                    </radialGradient>
                </defs>
                <g stroke="rgba(255, 255, 255, 0.45)" strokeWidth="2" fill="none">
                    <polyline points="470,340 470,320 490,320" />
                    <polyline points="930,400 930,420 910,420" />
                </g>

                <text
                    x="700"
                    y="370"
                    textAnchor="middle"
                    dominantBaseline="central"
                    fill="#ffffff"
                    fontSize="72"
                    fontWeight="700"
                    fontFamily="-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
                    letterSpacing="-1"
                >
                    Keybreak {version}
                </text>
            </Svg>
        </Wrapper>
    )
}
